import { Site } from './site';

export class SiteList {
    id: string;
    name: string;
    siteList: Site[] = [];
}
